require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _theming = require("../../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/TouchableRipple/index.tsx";

var TouchableRipple = function (_React$Component) {
  (0, _inherits2["default"])(TouchableRipple, _React$Component);

  function TouchableRipple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, TouchableRipple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(TouchableRipple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePressIn", function (e) {
      var _this$props = _this.props,
          centered = _this$props.centered,
          rippleColor = _this$props.rippleColor,
          onPressIn = _this$props.onPressIn,
          theme = _this$props.theme;
      onPressIn === null || onPressIn === void 0 ? void 0 : onPressIn(e);
      var dark = theme.dark,
          colors = theme.colors;
      var calculatedRippleColor = rippleColor || (0, _color["default"])(colors.text).alpha(dark ? 0.32 : 0.2).rgb().string();
      var button = e.currentTarget;
      var style = window.getComputedStyle(button);
      var dimensions = button.getBoundingClientRect();
      var touchX;
      var touchY;

      if (centered) {
        touchX = dimensions.width / 2;
        touchY = dimensions.height / 2;
      } else {
        var startX = e.nativeEvent.touches ? e.nativeEvent.touches[0].pageX : e.pageX;
        var startY = e.nativeEvent.touches ? e.nativeEvent.touches[0].pageY : e.pageY;
        touchX = startX - dimensions.left;
        touchY = startY - dimensions.top;
      }

      var size = centered ? Math.min(dimensions.width, dimensions.height) * 1.25 : Math.max(dimensions.width, dimensions.height) * 2;
      var container = document.createElement('span');
      container.setAttribute('data-paper-ripple', '');
      (0, _extends2["default"])(container.style, {
        position: 'absolute',
        pointerEvents: 'none',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        borderTopLeftRadius: style.borderTopLeftRadius,
        borderTopRightRadius: style.borderTopRightRadius,
        borderBottomRightRadius: style.borderBottomRightRadius,
        borderBottomLeftRadius: style.borderBottomLeftRadius,
        overflow: centered ? 'visible' : 'hidden'
      });
      var ripple = document.createElement('span');
      (0, _extends2["default"])(ripple.style, {
        position: 'absolute',
        pointerEvents: 'none',
        backgroundColor: calculatedRippleColor,
        borderRadius: '50%',
        transitionProperty: 'transform opacity',
        transitionDuration: "".concat(Math.min(size * 1.5, 350), "ms"),
        transitionTimingFunction: 'linear',
        transformOrigin: 'center',
        transform: 'translate3d(-50%, -50%, 0) scale3d(0.1, 0.1, 0.1)',
        opacity: '0.5',
        left: "".concat(touchX, "px"),
        top: "".concat(touchY, "px"),
        width: "".concat(size, "px"),
        height: "".concat(size, "px")
      });
      container.appendChild(ripple);
      button.appendChild(container);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          (0, _extends2["default"])(ripple.style, {
            transform: 'translate3d(-50%, -50%, 0) scale3d(1, 1, 1)',
            opacity: '1'
          });
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePressOut", function (e) {
      _this.props.onPressOut && _this.props.onPressOut(e);
      var containers = e.currentTarget.querySelectorAll('[data-paper-ripple]');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          containers.forEach(function (container) {
            var ripple = container.firstChild;
            (0, _extends2["default"])(ripple.style, {
              transitionDuration: '250ms',
              opacity: 0
            });
            setTimeout(function () {
              var parentNode = container.parentNode;

              if (parentNode) {
                parentNode.removeChild(container);
              }
            }, 500);
          });
        });
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(TouchableRipple, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          style = _this$props2.style,
          background = _this$props2.background,
          borderless = _this$props2.borderless,
          disabledProp = _this$props2.disabled,
          rippleColor = _this$props2.rippleColor,
          underlayColor = _this$props2.underlayColor,
          children = _this$props2.children,
          theme = _this$props2.theme,
          rest = (0, _objectWithoutProperties2["default"])(_this$props2, ["style", "background", "borderless", "disabled", "rippleColor", "underlayColor", "children", "theme"]);
      var disabled = disabledProp || !this.props.onPress;
      return React.createElement(_reactNative.TouchableWithoutFeedback, (0, _extends2["default"])({}, rest, {
        onPressIn: this.handlePressIn,
        onPressOut: this.handlePressOut,
        disabled: disabled,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 247
        }
      }), React.createElement(_reactNative.View, {
        style: [styles.touchable, borderless && styles.borderless, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 253
        }
      }, React.Children.only(children)));
    }
  }]);
  return TouchableRipple;
}(React.Component);

(0, _defineProperty2["default"])(TouchableRipple, "defaultProps", {
  borderless: false
});
(0, _defineProperty2["default"])(TouchableRipple, "supported", true);

var styles = _reactNative.StyleSheet.create({
  touchable: {
    position: 'relative'
  },
  borderless: {
    overflow: 'hidden'
  }
});

var _default = (0, _theming.withTheme)(TouchableRipple);

exports["default"] = _default;